import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import DashboardView from '@/views/dashboard/DashboardView.vue';
import OilNodeList from '@v/services/oilAnalysis/OilNodeList.vue';
import OilView from '@v/services/oilAnalysis/OilView.vue';
import OilAdminView from '@v/services/oilAnalysis/OilAdminView.vue';
import OilReport from '@v/services/oilAnalysis/OilReport.vue';
import OilReportDetails from '@v/services/oilAnalysis/OilReportDetails.vue';
import CoolantView from '@v/services/CoolantView.vue';
import SensorReadings from '@v/services/sensorReadings/SensorReadings.vue';
//import MonitorErrorsView from '@v/services/MonitorErrorsView.vue';
import WorkloadView from '@v/services/WorkloadView.vue';
import PModuleView from '@/views/system/nodes/PModuleView.vue';
import NodeSensorsView from '@/views/system/nodes/NodeSensorsView.vue';
import DtcpAccelerometerPModuleView from '@/views/system/nodes/DtcpAccelerometerPModuleView.vue';

import EmptyView from '@v/EmptyView.vue';
import PageNotFoundView from '@v/PageNotFoundView.vue';
import DiagnosticAssistanceView from '@/views/services/diagnosticAssistance/DiagnosticAssistanceView.vue';
import DiagnosticAssistance from '@/views/services/diagnosticAssistance/DiagnosticAssistance.vue';
import VibrationDiagnosticView from '@/views/services/vibrationDiagnostic/VibrationDiagnosticView.vue';
import VibrationDiagnostic from '@/views/services/vibrationDiagnostic/VibrationDiagnostic.vue';
import StateMonitorView from '@/views/services/StateMonitorView.vue';
import FormLogin from '@v/FormLogin.vue';
import authModule from '@/store/modules/authModule';
import AdministrationUsers from '@v/administration/users/Users.vue';
import AdministrationRoles from '@v/administration/roles/Roles.vue';
import AdministrationBrokerLogs from '@v/administration/brokerLogs/BrokerLogs.vue';
import AdministrationLogs from '@v/logs/LogsView.vue';

import HardwaresView from '@/views/system/hardware/HardwaresView.vue';
import NodesView from '@/views/system/nodes/NodesView.vue';
import DiagTasks from '@v/system/diagtasks/DiagTasks.vue';
import DiagTask from '@v/system/diagtasks/DiagTask.vue';
import TrendTasks from '@v/system/trends/TrendTasks.vue';
import TrendTask from '@v/system/trends/TrendTask.vue';
import TrendTaskView from '@v/system/trends/TrendTaskView.vue';
import BearingsView from '@v/system/bearings/BearingsView.vue';
import Bearings from '@v/system/bearings/Bearings.vue';
import BearingTasksView from '@v/system/bearingtasks/BearingTasksView.vue';
import BearingTasks from '@v/system/bearingtasks/BearingTasks.vue';
import SystemModules from '@v/system/modules/Modules.vue';
import StatusMonitors from '@v/system/modules/Monitors.vue';
import StatusMonitor from '@v/system/modules/Monitor.vue';
import SystemMeasurements from '@v/system/measurements/Measurements.vue';
import SystemModule from '@v/system/modules/Module.vue';
import ProfileView from '@v/user/ProfileView.vue';
import {PModuleType} from '@/enums/configs';
import enumsModule from '@/store/modules/enumsModule';
import PModuleDeveloperInfo from '@/views/system/nodes/PModuleDeveloperInfo.vue';
import PModuleEventBoundaryPassed from '@/views/system/nodes/PModuleEventBoundaryPassed.vue';
import EmptyPageView from '@v/EmptyPageView.vue';
import PModuleProblemLog from '@/views/system/nodes/PModuleProblemLog.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {path: '*', name: 'PageNotFound', component: PageNotFoundView},
  {
    path: '/pageNotFound',
    name: 'pageNotFound',
    meta: {layout: 'errorPage'},
    component: PageNotFoundView,
  },
  {
    path: '/emptyPage',
    name: 'emptyPage',
    meta: {layout: 'error'},
    props: true,
    component: EmptyPageView,
  },
  {
    path: '/',
    name: 'dashboard',
    meta: {layout: 'main', auth: true},
    component: DashboardView,
  },
  {
    path: '/oil',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'OilNode',
        meta: {layout: 'main', auth: true},
        component: OilNodeList,
      },
      {
        path: 'new',
        name: 'CreateOilNode',
        meta: {layout: 'main', auth: true},
        component: OilView,
      },
      {
        path: ':id',
        name: 'EditOilNode',
        meta: {layout: 'main', auth: true},
        component: OilView,
      },
      {
        path: ':id/admin',
        name: 'AdminOilNode',
        meta: {layout: 'main', auth: true},
        component: OilAdminView,
      },
      {
        path: 'report/:oid',
        meta: {layout: 'main', auth: true},
        component: EmptyView,
        children: [
          {
            path: '',
            name: 'OilReport',
            meta: {layout: 'main', auth: true},
            component: OilReport,
          },
          {
            path: 'new',
            name: 'CreateOilReport',
            meta: {layout: 'main', auth: true},
            component: OilReportDetails,
          },
          {
            path: ':id',
            name: 'EditOilReport',
            meta: {layout: 'main', auth: true},
            component: OilReportDetails,
          },
        ],
      },
    ],
  },
  {
    path: '/coolant',
    name: 'coolant',
    meta: {layout: 'main', auth: true},
    component: CoolantView,
  },
  {
    path: '/sensor-readings',
    name: 'sensor-readings',
    meta: {layout: 'main', auth: true},
    component: SensorReadings,
  },
  // {
  //   path: '/monitorErrors',
  //   name: 'monitorErrors',
  //   meta: {layout: 'main', auth: true},
  //   component: MonitorErrorsView,
  // },
  {
    path: '/workload',
    name: 'workload',
    meta: {layout: 'main', auth: true},
    component: WorkloadView,
  },
  {
    path: '/diagnosticAssistance',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'diagnosticAssistance',
        meta: {layout: 'main', auth: true},
        component: DiagnosticAssistanceView,
      },
      {
        path: 'new',
        name: 'CreateDiagnosticAssistance',
        meta: {layout: 'main', auth: true},
        component: DiagnosticAssistance,
      },
      {
        path: ':id',
        name: 'EditDiagnosticAssistance',
        meta: {layout: 'main', auth: true},
        component: DiagnosticAssistance,
      },
    ],
  },
  {
    path: '/vibrationDiagnostic',
    component: EmptyView,
    props: true,
    children: [
      {
        path: '',
        name: 'vibrationDiagnostic',
        meta: {layout: 'main', auth: true},
        component: VibrationDiagnosticView,
      },
      {
        path: 'new',
        name: 'CreateVibrationDiagnostic',
        meta: {layout: 'main', auth: true},
        component: VibrationDiagnostic,
      },
      {
        path: ':id',
        name: 'EditVibrationDiagnostic',
        meta: {layout: 'main', auth: true},
        component: VibrationDiagnostic,
      },
    ],
  },
  {
    path: '/stateMonitor',
    meta: {layout: 'main', auth: true},
    component: StateMonitorView,
  },
  {
    path: '/nodes',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'nodes',
        meta: {layout: 'main', auth: true},
        component: NodesView,
      },
      {
        path: ':id',
        name: 'node',
        meta: {layout: 'main', auth: true},
        component: NodesView,
      },
    ],
  },

  {
    path: '/hardware',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'hardwares',
        meta: {layout: 'main', auth: true},
        component: HardwaresView,
      },
      {
        path: ':hardwareId',
        name: 'HardwareView',
        meta: {layout: 'main', auth: true},
        component: HardwaresView,
        props: true,
      },
    ],
  },

  {
    path: '/measurements',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'measurements',
        meta: {layout: 'main', auth: true},
        component: SystemMeasurements,
      },
    ],
  },

  {
    path: '/diagtasks',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'DiagTask',
        meta: {layout: 'main', auth: true},
        component: DiagTasks,
      },
      {
        path: 'new',
        name: 'CreateDiagTask',
        meta: {layout: 'main', auth: true},
        component: DiagTask,
      },
      {
        path: ':id',
        name: 'EditDiagTask',
        meta: {layout: 'main', auth: true},
        component: DiagTask,
      },
    ],
  },

  {
    path: '/trends',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'SignalTrendTasks',
        meta: {layout: 'main', auth: true},
        component: TrendTasks,
      },
      {
        path: 'new',
        name: 'CreateSignalTrendTasks',
        meta: {layout: 'main', auth: true},
        component: TrendTask,
      },
      {
        path: ':id',
        name: 'EditSignalTrendTasks',
        meta: {layout: 'main', auth: true},
        component: TrendTask,
      },
    ],
  },

  {
    path: '/modules',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'modules',
        meta: {layout: 'main', auth: true},
        component: SystemModules,
      },
      {
        path: ':type',
        name: 'CreateSystemModule',
        meta: {layout: 'main', auth: true},
        component: SystemModule,
      },
      {
        path: ':type/:hardware/:hardwareType/:port',
        name: 'CreateSystemModuleFromHardware',
        meta: {layout: 'main', auth: true},
        component: SystemModule,
        props: true,
      },
      {
        path: ':type/:id',
        name: 'EditSystemModule',
        meta: {layout: 'main', auth: true},
        component: SystemModule,
      },
    ],
  },

  {
    path: '/monitor',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'monitor',
        meta: {layout: 'main', auth: true},
        component: StatusMonitors,
      },
      {
        path: ':type',
        name: 'CreateMonitor',
        meta: {layout: 'main', auth: true},
        component: StatusMonitor,
      },
      {
        path: ':type/:id',
        name: 'EditMonitor',
        meta: {layout: 'main', auth: true},
        component: StatusMonitor,
      },
      {
        path: ':type/:id',
        name: 'EditMonitorStatesTasks',
        meta: {layout: 'main', auth: true},
        component: StatusMonitor,
      },
      {
        path: ':type/:id',
        name: 'EditMonitorChildTasks',
        meta: {layout: 'main', auth: true},
        component: StatusMonitor,
      },
      {
        path: ':type/:id',
        name: 'EditMonitorBoundaryTasks',
        meta: {layout: 'main', auth: true},
        component: StatusMonitor,
      },
    ],
  },

  {
    path: '/sensors',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'sensors',
        meta: {layout: 'main', auth: true},
        component: SystemModules,
      },
      {
        path: ':type',
        name: 'CreateSensor',
        meta: {layout: 'main', auth: true},
        component: SystemModule,
      },
      {
        path: ':type/:hardware/:hardwareType/:port',
        name: 'CreateSensorFromHardware',
        meta: {layout: 'main', auth: true},
        component: SystemModule,
        props: true,
      },
      {
        path: ':type/:id',
        name: 'EditSensor',
        meta: {layout: 'main', auth: true},
        component: SystemModule,
      },
    ],
  },

  {
    path: '/bearings',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'Bearings',
        meta: {layout: 'main', auth: true},
        component: BearingsView,
      },
      {
        path: 'new',
        name: 'CreateBearings',
        meta: {layout: 'main', auth: true},
        component: Bearings,
      },
      {
        path: ':id',
        name: 'EditBearings',
        meta: {layout: 'main', auth: true},
        component: Bearings,
      },
    ],
  },

  {
    path: '/bearingtasks',
    meta: {layout: 'main', auth: true},
    component: EmptyView,
    children: [
      {
        path: '',
        name: 'BearingTasks',
        meta: {layout: 'main', auth: true},
        component: BearingTasksView,
      },
      {
        path: 'new',
        name: 'CreateBearingTasks',
        meta: {layout: 'main', auth: true},
        component: BearingTasks,
      },
      {
        path: ':id',
        name: 'EditBearingTasks',
        meta: {layout: 'main', auth: true},
        component: BearingTasks,
      },
    ],
  },

  {
    path: '/view/crm-modules/:id',
    name: 'crmModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.CrmModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/server-monitor-modules/:id',
    name: 'serverMonitorModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.ServerMonitorModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/clean-storage-modules/:id',
    name: 'cleanStorageModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.CleanStorageModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/dtcp-tachometer-modules/:id',
    name: 'dtcpTahoModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpTahoModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/dtcp-server-modules/:id',
    name: 'dtcpServerModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpServerModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/dtcp-energy-modules/:id',
    name: 'dtcpEnergyModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpEnergyModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/dtcp-temperature-modules/:id',
    name: 'dtcpTemperatureModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpTemperatureModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/dtcp-accelerometer-modules/:id',
    name: 'dtcpAccelerometerModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpAccelerometerModule},
    component: DtcpAccelerometerPModuleView,
    props: true,
  },
  {
    path: '/view/bearing-control-modules/:id',
    name: 'bearingControlModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.BearingControlModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/pinger-modules/:id',
    name: 'pingerModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.PingerModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/heater-monitor-modules/:id',
    name: 'heaterMonitorModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.HeaterMonitorModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/dtcp-emulator-modules/:id',
    name: 'dtcpEmulatorModuleNew',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpEmulatorModule},
    component: PModuleView,
    props: true,
  },
  {
    path: '/view/node-sensors/:id',
    name: 'nodeSensorsView',
    meta: {layout: 'main', auth: true},
    component: NodeSensorsView,
    props: true,
  },
  {
    path: '/monitor/monitor-states-tasks/:id',
    name: 'MonitorStatesTasksShow',
    meta: {layout: 'main', auth: true},
    component: SystemModule,
    props: true,
  },
  {
    path: '/monitor/monitor-boundary-tasks/:id',
    name: 'MonitorBoundaryTasksShow',
    meta: {layout: 'main', auth: true},
    component: SystemModule,
    props: true,
  },
  {
    path: '/monitor/monitor-child-tasks/:id',
    name: 'MonitorChildTasksShow',
    meta: {layout: 'main', auth: true},
    component: SystemModule,
    props: true,
  },
  {
    path: '/view/signal-trend-tasks/:id',
    name: 'SignalTrendTasksShow',
    meta: {layout: 'main', auth: true},
    component: TrendTaskView,
    props: true,
  },

  {
    path: '/admin/crm-modules/:id',
    name: 'crmModuleDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.CrmModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/server-monitor-modules/:id',
    name: 'serverMonitorModuleDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.ServerMonitorModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/clean-storage-modules/:id',
    name: 'cleanStorageModuleDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.CleanStorageModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/dtcp-tachometer-modules/:id',
    name: 'dtcpTahoModuleDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpTahoModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/dtcp-server-modules/:id',
    name: 'dtcpServerModuleDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpServerModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/dtcp-energy-modules/:id',
    name: 'dtcpEnergyModuleDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpEnergyModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/dtcp-temperature-modules/:id',
    name: 'dtcpTemperatureModuleDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpTemperatureModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/dtcp-accelerometer-modules/:id',
    name: 'dtcpAccelerometerModuleDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpAccelerometerModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/heater-monitor-modules/:id',
    name: 'heaterMonitorModuleDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.HeaterMonitorModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/monitor-states-tasks/:id',
    name: 'monitorStatesTasksDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.MonitorStatesTasks},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/monitor-boundary-tasks/:id',
    name: 'monitorBoundaryTasksDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.MonitorBoundaryTasks},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/monitor-child-tasks/:id',
    name: 'monitorChildTasksDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.MonitorChildTasks},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/signal-trend-tasks/:id',
    name: 'signalTrendTasksDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.SignalTrendTasks},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/bearing-control-modules/:id',
    name: 'bearingControlModuleEventDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.BearingControlModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/pinger-modules/:id',
    name: 'pingerModuleEventDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.PingerModule},
    component: PModuleDeveloperInfo,
    props: true,
  },
  {
    path: '/admin/dtcp-emulator-modules/:id',
    name: 'dtcpEmulatorModuleEventDeveloperInfo',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpEmulatorModule},
    component: PModuleDeveloperInfo,
    props: true,
  },

  {
    path: '/boundary/crm-modules/:id',
    name: 'crmModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.CrmModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/server-monitor-modules/:id',
    name: 'serverMonitorModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.ServerMonitorModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/clean-storage-modules/:id',
    name: 'cleanStorageModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.CleanStorageModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/dtcp-taho-modules/:id',
    name: 'dtcpTahoModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpTahoModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/dtcp-server-modules/:id',
    name: 'dtcpServerModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpServerModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/dtcp-energy-modules/:id',
    name: 'dtcpEnergyModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpEnergyModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/dtcp-temperature-modules/:id',
    name: 'dtcpTemperatureModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpTemperatureModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/dtcp-accelerometer-modules/:id',
    name: 'dtcpAccelerometerModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpAccelerometerModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/bearing-control-modules/:id',
    name: 'bearingControlModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.BearingControlModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/pinger-modules/:id',
    name: 'pingerModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.PingerModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },
  {
    path: '/boundary/dtcp-emulator-modules/:id',
    name: 'dtcpEmulatorModuleEventBoundaryPassed',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpEmulatorModule},
    component: PModuleEventBoundaryPassed,
    props: true,
  },

  {
    path: '/problemLog/crm-modules/:id',
    name: 'crmModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.CrmModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/server-monitor-modules/:id',
    name: 'serverMonitorModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.ServerMonitorModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/clean-storage-modules/:id',
    name: 'cleanStorageModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.CleanStorageModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/dtcp-taho-modules/:id',
    name: 'dtcpTahoModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpTahoModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/dtcp-server-modules/:id',
    name: 'dtcpServerModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpServerModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/dtcp-energy-modules/:id',
    name: 'dtcpEnergyModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpEnergyModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/dtcp-temperature-modules/:id',
    name: 'dtcpTemperatureModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpTemperatureModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/dtcp-accelerometer-modules/:id',
    name: 'dtcpAccelerometerModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.DtcpAccelerometerModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/bearing-control-modules/:id',
    name: 'bearingControlModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.BearingControlModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/pinger-modules/:id',
    name: 'pingerModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.PingerModule},
    component: PModuleProblemLog,
    props: true,
  },
  {
    path: '/problemLog/heater-monitor-modules/:id',
    name: 'heaterMonitorModuleProblemLog',
    meta: {layout: 'main', auth: true, type: PModuleType.HeaterMonitorModule},
    component: PModuleProblemLog,
    props: true,
  },

  {
    path: '/login',
    name: 'login',
    meta: {layout: 'auth', auth: false},
    component: FormLogin,
  },
  {
    path: '/administrationUsers',
    name: 'administrationUsers',
    meta: {layout: 'main', auth: true},
    component: AdministrationUsers,
  },
  {
    path: '/administrationRoles',
    name: 'administrationRoles',
    meta: {layout: 'main', auth: true},
    component: AdministrationRoles,
  },
  {
    path: '/administrationBrokerLogs',
    name: 'administrationBrokerLogs',
    meta: {layout: 'main', auth: true},
    component: AdministrationBrokerLogs,
  },
  {
    path: '/administrationLogs',
    name: 'administrationLogs',
    meta: {layout: 'main', auth: true},
    component: AdministrationLogs,
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {layout: 'main', auth: true},
    component: ProfileView,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: function(to) {
    return new Promise(resolve => {
      setTimeout(() => {
        if (to.hash) {
          resolve({selector: to.hash});
        } else {
          resolve({x: 0, y: 0});
        }
      }, 1000);
    });
  },
});

async function preload() {
  if (authModule.accessToken && !enumsModule.loaded) await enumsModule.fetchAll();
}

router.beforeEach(async (to, from, next) => {
  if (to.meta?.auth && to.name !== 'login' && !authModule.getAccessToken) next({name: 'login'});
  else if (to.name === 'login' && authModule.getAccessToken) {
    await preload().then(() => next({name: 'dashboard'}));
  } else if (to.meta?.layout === 'error' || to.meta?.layout === 'errorPage') {
    next();
  } else {
    await preload().then(() => next());
  }
});

export default router;
